"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _components = require("@theme-ui/components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _withValidation = _interopRequireDefault(require("../../lib/withValidation"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _Label = _interopRequireDefault(require("../Label/Label"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RadioWithImage = function RadioWithImage(_ref) {
  var value = _ref.value,
      label = _ref.label,
      image = _ref.image,
      selected = _ref.selected,
      onClick = _ref.onClick,
      name = _ref.name,
      props = _objectWithoutPropertiesLoose(_ref, ["value", "label", "image", "selected", "onClick", "name"]);

  return (0, _themeUi.jsx)(_Label["default"], _extends({
    htmlFor: value,
    name: name,
    value: value
  }, props), (0, _themeUi.jsx)("div", {
    sx: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      borderBottom: 'solid 2px',
      borderBottomColor: function borderBottomColor() {
        return selected ? 'primaryList' : 'transparent';
      },
      opacity: function opacity() {
        return selected ? 1 : 0.6;
      },
      width: '100%',
      pb: '6px'
    }
  }, (0, _themeUi.jsx)(_Image["default"], {
    sx: {
      width: 4,
      height: 4,
      margin: 'auto',
      mb: 2
    },
    src: image,
    alt: label
  }), (0, _themeUi.jsx)(_Text["default"], {
    variant: "subtitle"
  }, label), (0, _themeUi.jsx)("div", {
    sx: {
      display: 'none'
    }
  }, (0, _themeUi.jsx)(_components.Radio, {
    id: value,
    name: name,
    value: value,
    onClick: onClick,
    sx: {
      display: 'none'
    }
  }))));
};

RadioWithImage.displayName = 'RadioWithImage';
RadioWithImage.propTypes = {
  value: _propTypes["default"].string,
  label: _propTypes["default"].string,
  image: _propTypes["default"].string,
  selected: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  name: _propTypes["default"].string
};

var _default = (0, _withValidation["default"])(RadioWithImage);

exports["default"] = _default;